import { useMutation } from "react-query";
import { updateInterventionHistory } from "api/customers";
import { useGlobalToast } from "components/GlobalToastProvider";

const useUpdateInterventionHistory = (options: Record<string, any> = {}) => {
  const { onSuccess = () => {}, onError = () => {}, ...otherOptions } = options;
  const { showToast } = useGlobalToast();

  const { mutate, isLoading, ...rest } = useMutation(
    ({ id, payload }: { id: number; payload: Record<string, any> }) =>
      updateInterventionHistory(id, payload),
    {
      onSuccess: (response, variables) => {
        showToast({ message: "Intervention record updated successfully." });
        onSuccess(response, variables);
      },
      onError: (error: any) => {
        const errorMessage = error?.response?.data?.error || "Failed to update intervention record";
        showToast({ message: errorMessage, errorState: true });
        onError(error);
      },
      ...otherOptions,
    }
  );

  return {
    updateInterventionHistoryMutation: mutate,
    isUpdateInterventionHistoryLoading: isLoading,
    ...rest,
  };
};

export default useUpdateInterventionHistory;
